/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIChannelRequest
 */
export interface APIChannelRequest {
    /**
     * 
     * @type {string}
     * @memberof APIChannelRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof APIChannelRequest
     */
    description?: string;
}

/**
 * Check if a given object implements the APIChannelRequest interface.
 */
export function instanceOfAPIChannelRequest(value: object): value is APIChannelRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function APIChannelRequestFromJSON(json: any): APIChannelRequest {
    return APIChannelRequestFromJSONTyped(json, false);
}

export function APIChannelRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIChannelRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function APIChannelRequestToJSON(value?: APIChannelRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'description': value['description'],
    };
}

